export class Congreso {

    constructor (
        public _id ?: string,
        public titulo_es ?: string,
        public titulo_en ?: string,
        public desc_es ?: string,
        public desc_en ?: string,
        public lugar ?: string,
        public sociedadOrganizadora ?: string,
        public contactosPago ?: string,
        public contactosTrabajos ?: string,
        // Fecha Inicio/fin congreso
        public fechaInicioCongreso ?: number,
        public fechaFinCongreso ?: number,
        // Fecha Inicio/fin inscripcion
        public fechaInicioInscripcion ?: number,
        public fechaFinInscripcion ?: number,
        // Fecha Inicio/fin presentacion de trabajos
        public fechaInicioTrabajos ?: number,
        public fechaFinTrabajos ?: number,
        public categoriasInscripcion ?: any[],
        public actividades ?: any[],
        public active ?: boolean
    ) { }

}



// WEBPACK FOOTER //
// ./src/app/models/congreso.model.ts